import type {
	DocumentLink,
	DocumentLinkIds,
} from "web_myplann/Portfolio/Types/documentLink";
import { PortfolioItemKind } from "web_myplann/Portfolio/Types/portfolioItemKind";

export const mapDocumentLinkToIds = (link: DocumentLink): DocumentLinkIds =>
	link.kind === PortfolioItemKind.Property
		? { propertyId: link.id }
		: { portfolioId: link.id };
